import { TagDto } from "src/swagger/api.client.generated";

export class ScoreData {
  constructor(
    text: string,
    stars: number,
    scoreType: ScoreType,
    autoCompleteData?: string[],
    selectedTags?: TagDto[],
    tags?: TagDto[]
  ) {
    this.text = text;
    this.stars = stars;
    this.scoreType = scoreType;
    this.autoCompleteData = autoCompleteData;
    this.tags = tags;
    this.selectedTags = selectedTags;
  }

  autoCompleteData: string[] = [];
  scoreType: ScoreType;
  text: string;
  stars: number;
  tags: TagDto[] = [];
  selectedTags: TagDto[] = [];
  /** True when the dialog edits an existing item rather than adding one (FLIP-345: S06 skips edits). */
  isEdit?: boolean;

}

export enum ScoreType {
  Halo,
  Zombie
}
